import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import ElementPlus from 'element-plus'// element
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import 'element-plus/dist/index.css'
import common from '@/assets/js/common.js'// 公用方法
import commonData from '@/assets/js/commonData.js'// 公共数据
import moment from 'moment'// 时间插件
import '@/assets/icon/iconfont.css' // 引入阿里图标 CSS
import addressSelection from './components/common/addressSelection'// 地址选择组件
import '@/assets/css/public.scss'
import * as echarts from 'echarts' // echarts
import vueSeamless from 'vue-seamless-scroll/src'

const app = createApp(App)
app.config.globalProperties.$common = common
app.config.globalProperties.$commonData = commonData
app.config.globalProperties.$moment = moment
app.config.globalProperties.$echarts = echarts
app.component('address-selection', addressSelection)
// 防止修改sessionStorage
window.addEventListener('storage', (e) => {
  sessionStorage.setItem(e.key, e.oldValue)
})

// 全局路由守卫
router.beforeEach((to, from, next) => {
  if (to.path === '/index') {
    next({ path: '/homePage' })
    // const userAgent = navigator.userAgent.toLowerCase();
    // const mobileKeywords = ['mobile', 'android', 'iphone', 'ipad', 'windows phone'];
    // const isMobile = mobileKeywords.some(keyword => userAgent.includes(keyword));
    // if (isMobile) {
    //   next({ path: '/homePageApp' })
    // } else {
    //   next({ path: '/homePage' })
    // }
  }
  next()
})
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}
app.use(store).use(router).use(ElementPlus, { locale: zhCn }).use(vueSeamless).mount('#app')
